// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"WJ-z","carouselContainer":"XJ-z"};